import { t } from "i18next";

export const GetTrans = (value) => {
  return t(value);
};
